/*
 *ajax
 */

//引入
import request from "../utils/request";

export function tzdH5(params) {
    return request({
        method: 'get',
        url: '/prod-api/deposit/api/wxzjjctzd/tzdH5',
        params,
    })
}


export function crateOrderId(id) {
    return request({
        method: 'post',
        url: '/prod-api/order/api/wxzjtzdorder/crateOrder/' + id,
    })
}